import { AccountState } from './account.state';
import * as fromAction from './account.action';
import { adapter } from './account.entity';
import { Action, createReducer, on } from '@ngrx/store';
import { AccountFilter } from '../models/account.filter';
import { Account } from '../models/account';

export const initialState: AccountState = adapter.getInitialState({
  kycDocuments: [],
  bankAccounts: [],
  error: null,
  totalCount: 0,
  filter: new AccountFilter(),
  current: [],
});

const reducer = createReducer(
  initialState,
  on(fromAction.AddAccount, (state, { account }) => {
    return adapter.addOne(account, state);
  }),
  on(fromAction.AddAccounts, (state, { accounts }) => {
    return adapter.setAll(accounts, state);
  }),

  on(fromAction.AddTotalCount, (state, { totalCount }) => {
    return adapter.addMany([], { ...state, totalCount: totalCount });
  }),

  on(fromAction.AddCurrentAccount, (state, { accounts }) => {
    return adapter.addMany([], { ...state, current: accounts });
  }),

  on(fromAction.AddError, (state, { error }) => {
    return adapter.addMany([], { ...state, error: error });
  }),

  on(fromAction.AddAccountFilter, (state, { filter }) => {
    return adapter.addMany([], { ...state, filter: filter });
  }),

  on(fromAction.RemoveAccountFilter, (state, {}) => {
    return adapter.addMany([], { ...state, guideProfile: null });
  }),

  on(fromAction.AddOrUpdateCurrentAccount, (state, { account }) => {
    const allCurrents = JSON.parse(JSON.stringify(state.current)) as Account[];

    const existingIndex = allCurrents.findIndex((x) => x.id === account.id);

    if (existingIndex > -1) {
      allCurrents.splice(existingIndex, 1, account);
    } else {
      allCurrents.push(account);
    }

    return adapter.addMany([], { ...state, current: allCurrents });
  }),

  on(fromAction.UpdateWallet, (state, { accountId, wallet }) => {
    const existing = JSON.parse(JSON.stringify(state.entities[accountId])) as Account;

    if (existing) {
      // Finding the existing wallet array index
      const existingWalletIndex = existing.wallets.findIndex((x) => x.id === wallet.id);

      wallet.amountViewed = true;
      // Replace the new wallet
      existing.wallets.splice(existingWalletIndex, 1, wallet);

      return adapter.updateOne({ id: accountId, changes: existing }, state);
    } else {
      return adapter.addMany([], { ...state });
    }
  }),

  on(fromAction.AddWallet, (state, { accountId, wallet }) => {
    const existing = JSON.parse(JSON.stringify(state.entities[accountId])) as Account;

    if (existing) {
      existing.wallets.push(wallet);
      return adapter.updateOne({ id: accountId, changes: existing }, state);
    } else {
      return adapter.addMany([], { ...state });
    }
  }),

  /*on(fromAction.AddCard, (state, { accountId, card }) => {
    const existing = JSON.parse(JSON.stringify(state.entities[accountId])) as Account;

    if (existing) {
      existing.cards.push(card);
      return adapter.updateOne({ id: accountId, changes: existing }, state);
    } else {
      return adapter.addMany([], { ...state });
    }
  }),*/
  on(fromAction.AddKycDocument, (state, { kycDocuments }) => {
    return adapter.addMany([], { ...state, kycDocuments });
  }),
  on(fromAction.AddBankAccounts, (state, { accounts }) => {
    return adapter.addMany([], { ...state, bankAccounts: accounts });
  })
);

export function accountStoreReducer(state: AccountState = initialState, action: Action): AccountState {
  return reducer(state, action);
}
